function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "checkmark-circle-outline"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12 2a10 10 0 1010 10A10 10 0 0012 2zm0 18a8 8 0 118-8 8 8 0 01-8 8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7 8.39l-3.78 5-1.63-2.11a1 1 0 00-1.58 1.23l2.43 3.11a1 1 0 00.79.38 1 1 0 00.79-.39l4.57-6a1 1 0 10-1.6-1.22z"
})));

function SvgIconCheckmarkCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8ZyBkYXRhLW5hbWU9IkxheWVyIDIiPgogICAgICAgIDxnIGRhdGEtbmFtZT0iY2hlY2ttYXJrLWNpcmNsZS1vdXRsaW5lIj4KICAgICAgICAgICAgPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBvcGFjaXR5PSIwIi8+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMiAyYTEwIDEwIDAgMSAwIDEwIDEwQTEwIDEwIDAgMCAwIDEyIDJ6bTAgMThhOCA4IDAgMSAxIDgtOCA4IDggMCAwIDEtOCA4eiIvPgogICAgICAgICAgICA8cGF0aAogICAgICAgICAgICAgICAgZD0iTTE0LjcgOC4zOWwtMy43OCA1LTEuNjMtMi4xMWExIDEgMCAwIDAtMS41OCAxLjIzbDIuNDMgMy4xMWExIDEgMCAwIDAgLjc5LjM4IDEgMSAwIDAgMCAuNzktLjM5bDQuNTctNmExIDEgMCAxIDAtMS42LTEuMjJ6Ii8+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgIconCheckmarkCircleOutline as ReactComponent };